import {expect, getSdk, getMock, getRegistry, spy} from '../test/test';
import SDK from '../SDK';

describe('RingCentral.subscription.CachedSubscription', function() {

    describe('restore', function() {

        it.skip('sets appropriate event filters if subscription is not alive', function() {});
        it.skip('sets appropriate event filters if subscription is never existed', function() {});
        it.skip('renews subscription if cache data is OK', function() {});
        it.skip('re-subscribes with default event filters when renew fails', function() {});

    });

    describe('renew', function() {
    });

    describe('resubscribe', function() {
    });

});



/** WEBPACK FOOTER **
 ** ./src/subscription/CachedSubscription-spec.js
 **/